import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { CacheProvider } from '@emotion/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { emotionCache } from './emotion-setup';
import WaitlistLandingPage from './pages/WaitlistLandingPage';
import WaitlistAdminDashboard from './components/Admin/WaitlistAdminDashboard';
import ProtectedRoute from './components/Auth/ProtectedRoute';

function App() {
  return (
    <CacheProvider value={emotionCache}>
      <ChakraProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<WaitlistLandingPage />} />
            <Route path="/waitlist" element={<WaitlistLandingPage />} />
            <Route
              path="/admin/waitlist"
              element={
                <ProtectedRoute adminOnly>
                  <WaitlistAdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </ChakraProvider>
    </CacheProvider>
  );
}

export default App;
